module.exports = __webpack_public_path__ + "media/images/icon_friend_white-f7df966afa78dfc1d4212d29b4d7576a.png";